import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.DealerGroup.Delete.IRequest;
type Response = Api.Core.DealerGroup.Delete.IResponse;
type Headers = Api.Core.DealerGroup.Delete.IHeaders;
const url = '/api/DealerManagement/DealerGroup/:id';
export default async function dealerGroupDeleteApi({ id }: Request): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.delete,
    url: createPathFromRoute(url, { id }),
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
